module.exports = __webpack_public_path__ + "img/card7.554f1843.png";